<template>
  <div class="edit-module-content-main">
    <div class="edit-editor-title">
      <div class="edit-back" @click="back">
        <i class="iconfont iconchevron-left"></i>返回
      </div>
      <div class="edit-module-name" :class="['pointer']"
           @click="editModuleTitle()">
        <span class="text-overflow">{{title || currentInfo.title}}</span>
        <i style="color: #C2C2C2;" class="pointer iconfont iconedit-" @click="editModuleTitle"></i>
      </div>
      <button class="edit-module-save" @click="debounceSave" :disabled="!infoNotEmpty(formData, currentInfo.type)">保存
      </button>
    </div>
    <w-form-data ref="WForm" :form-data="formData" :form-list="formList" :picker-options="pickerOptions"
                 :module-type="currentInfo.type" @change="endAtChange" @selectCity="selectCity"></w-form-data>
    <!-- @selectMajor="selectMajor" @selectDegree="selectDegree"
    @selectUniversity="selectUniversity" -->
    <template v-if="currentInfo.type !== 'honor'">
    <div class="edit-module-item-name margin-top-24 flex-c" style="width:100%;justify-content:space-between;" v-if="currentInfo.type !== 'personal_summary' && currentInfo.type !== 'skill_list'">
		  经历描述
      <button class="ai-cvs-entry" @click="handleClickAiBtn">AI 简历润色</button>
	  </div>
      <div class="position-r">
        <text-editor
					:form-data="formData"
					@useOptimizationContent="useOptimizationContent"
					@handleSaveCurrentForm="debounceSave"
				></text-editor>
      </div>
    </template>
    <cv-auxiliary>
      <div class="module-delete" slot="operation" @click="deleteExperience" v-if="deleteIconShow">
        <i class="iconfont icontrash-"></i>
        <span>删除这段经历</span>
      </div>
    </cv-auxiliary>
    <!--    <div class="edit-editor-btn">-->
    <!--      <div>-->
    <!--        <div class="edu-item" @click="deleteExperience" v-if="deleteIconShow">-->
    <!--          <i class="iconfont icontrash-"></i>-->
    <!--          <span>删除这段经历</span>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div class="btn-box">-->
    <!--        <button class="close-btn" @click="back">取消</button>-->
    <!--        <button class="complete-btn" @click="debounceSave" :disabled="!infoNotEmpty(formData, currentInfo.type)">保存</button>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>
<script>
	import { mapState, mapActions, mapMutations } from 'vuex'
	import moment from 'moment'
	import WFormData from '../../../../../components/editor/w-form-data'
	import cvAuxiliary from './cv-auxiliary'
	import textEditor from './text-editor'
	import rules from '@/assets/json/rules'
	import { cvMixin } from '../../../../../assets/js/mixins'
	import editorModule from '../../../../../assets/json/editor-module.json'
	import api from '../../../../../api'
  import { Message } from 'element-ui'
	import { setEditNumLocalStorage, debounce } from '@/assets/js/util'

	export default {
		name: 'customModuleForm',
		mixins: [ cvMixin ],
		data () {
			return {
				debounceSave: null,
				isSave: false,
				title: '', // 模块标题，只在修改标题后使用
				pickerOptions: {},
				oldFormData: {},
				degreeData: {}
			}
		},
		computed: {
			...mapState('cvsEditor', [ 'cvToken', 'cvInfo', 'editModuleData' ]),
			...mapState('cvs', [ 'cv', 'editorCvToken', 'highlightShow' ]),
			...mapState('editor', [ 'cvDetail', 'currentInfo', 'backUpInfo', 'checkCloseEditModule', 'quitResumeEditor' ]),
			...mapState('experience', [ 'experienceList', 'experienceTitleList', 'experienceCustomSections' ]),
			// 当前编辑的页面的数据
			formList () {
				let { type } = this.currentInfo
				type = typeof type === 'number' ? 'custom' : type
				if (type !== 'personal_summary' && type !== 'skill_list' && editorModule[`${ type }_form`]) {
					return JSON.parse(JSON.stringify(editorModule[`${ type }_form`]))
				} else {
					return []
				}
			},
			// 简历里面当前自定义模块的经历
			experienceInfos () {
				let { type, data: { custom_section_id } } = this.currentInfo
				return this.$store.state.editor[type] || this.$store.state.editor.create_custom || []
			},
			// 当前编辑的模块经历库里面的内容
			experience () {
				let { type, data: { custom_section_id } } = this.currentInfo
        return type !== 'custom' ?  this.experienceList[type] : null
			},
			// 是否显示删除按钮
			deleteIconShow () {
				return this.currentInfo.operation === 'edit' && this.customSectionId === this.formData.custom_section_id
			},
			// 当前编辑自定义模块的custom_id
			customSectionId () {
				//单独处理导师订单
				if (this.isMentorEditor) {
					let { sections_position } = this.cvDetail.submodule_info
					let { type, data: { custom_section_id } } = this.currentInfo
					if (custom_section_id) {
						return custom_section_id
					} else {
						let modelItem = sections_position.filter(item => item.type === type || item.id === type)
						if (modelItem.length) {
							return modelItem[0].id
						}
					}
				} else {
					// 经历库有此模块，并且有数据
					if (this.experience && this.experience.length) {
						return this.experience[0].custom_section_id
					} else {
						let { type } = this.currentInfo
						let hasModel = this.experienceCustomSections.filter(item => item.id === type || (item.category === type && item.category !== 'custom'))
						if (hasModel.length) {
							return hasModel[0].id
						}
					}
				}
			},
			isMentorEditor () {
				return window.location.href.includes('mentor')
			}
		},
		mounted () {
			this.initDateOptions()
			this.initFormData()
		},
		components: {
			textEditor,
			WFormData,
			cvAuxiliary
		},
		watch: {
			checkCloseEditModule: function (state) {
				if (state) {
					this.back()
					//设置是否需要取消当前编辑状态，并返回
					setTimeout(() => {
						this.setCheckCloseEditModule(false)
					}, 10)
				}
			},
			// 监听是否退出模块编辑
      quitResumeEditor(value){
			  if(value) {
          // 还原状态
			    this.setQuitResumeEditor(false);
          // 执行退出模块编辑
          this.back();
        }
      },
		},
		created () {
			this.debounceSave = debounce(this.save, 300)
		},
		methods: {
			...mapActions('cvsEditor', [ 'createdOrg', 'editOrg' ]),
			...mapMutations('editor', [ 'setCurrentInfo', 'setModuleData', 'setCheckCloseEditModule', 'setQuitResumeEditor' ]),
			...mapActions('editor', [ 'createCustom', 'createCustomInfo', 'updateCustomInfo', 'createCvDetail', 'updateCvDetail' ]),
			...mapMutations('experience', [ 'updateExperienceModule', 'deleteExperienceSelect', 'updateExperienceTitleName', 'updateExperienceTitleList' ]),
			...mapActions('manage', [ 'getMenuList' ]),

      showAIDialog () {
        this.$store.dispatch('app/setAlertData', {
          show: true,
          type: 'ai-cvs'
        })
      },
			//是否显示标题
			showEditModuleTitle () {
				let { type } = this.currentInfo
				let { basic_info } = this.cvDetail
				let isKind = !!(basic_info.kind === 'sample' || basic_info.kind === 'template')
				let moduleList = this.experienceList[type] && this.experienceList[type].filter(item => item.custom_section_id === this.customSectionId).length
				return !isKind && moduleList
			},
			// 获取check时候的title
			getRulesTitle (title, check) {
				for (let i = 0; i < rules.rules.length; i++) {
					if (rules.rules[i].name === title || (check && check.name === rules.rules[i].name)) {
						return rules.rules[i].title
					}
				}
				return '提示'
			},
			// change
			change () {
				// console.log(JSON.stringify(this.formData, null, 4))
			},
			// 保存
			async save () {
				// if (this.isSave) return
				// this.isSave = true
				setEditNumLocalStorage()
				let valid = this.$refs['WForm'].formValidate()
				if (!valid) return false
				// this.formData.description = this.formData.description ?  this.formData.description.replace(/(?<= )class=".*?"/gi, '').replace(/<div/gi, '<p').replace(/\/div>/gi, '\/p>') : null
				//判断是不是导师简历
				let basicMentorId = this.cvDetail.basic_info.mentor_id
				let { id, mentor_id } = this.formData
				// 找到在经历库中当前 id 所在的位置
				const experienceIndex = this.experience ? this.experience.findIndex(item => item.id === id) : -1
				/*
        1. experienceIndex 大于 -1 的话说明当前经历是用户已有经历，需要对比是否修改
         **/
				// 导师经历
				if (mentor_id && this.isMentorEditor) {
					this.experienceChange('update')
				} else if (experienceIndex > -1) {
					let experienceInfo = this.experience[experienceIndex]
					if (this.contrastInitData(this.formData, experienceInfo)) {
						if (await this.verifyFormData(this.formData)) {
							const alertData = {
								...this.alertData,
								messageTitle: '修改同步提示',
								confirmButtonText: '同步',
								cancelButtonText: '不同步',
								messageContent: `<p>此段经历在其他简历中被引用，</p><p style="color: #FF453E">是否同步修改到其他简历？</p>`,
								confirm: async close => {
									this.experienceChange('update')
									close()
								},
								cancel: close => {
									this.experienceChange('create')
									close()
								},
							}
							this.setAlertData(alertData)
						} else {
							this.experienceChange('update')
						}
					} else {
						// 如果和编辑时的 id 一致，就直接关闭窗口
						if (this.formData.id === this.backUpInfo.data.id) {
							this.resetEditState()
						} else {
							this.updateCvDetail({ ...this.formData, saveModule: true })
						}
					}
				} else {
					this.experienceChange('create')
				}
				// this.experienceChange('update')
				// 提交保存模块监听
				this.$eventBus.$emit("saveEditorModule", 'custom')
			},
			// 更新或者创建经历
			async experienceChange (operation) {
				let { type } = this.currentInfo
				let { basic_info } = this.cvDetail
				type = typeof type === 'number' ? 'custom' : type
				let payload = {
					...this.formData,
					start_at: this.formData.start_at ? moment.utc(this.formData.start_at) : null,
					end_at: this.formData.end_at ? moment.utc(this.formData.end_at) : null,
					lang: this.cvDetail.basic_info.lang,
				}
				if (window.location.href.includes('mentor')) {
					payload.is_mentor = true
					payload.type = 'mentor'
				}
				//创建模块时，如果没有大标题名称，添加大标题名称
				if (!payload.section_title) {
					payload.section_title = this.currentInfo.title
				}

				// 编辑
				if (operation === 'update') {
					let res = await this.updateCustomInfo(payload)
					if (res.code === 1000) {
						this.cvDetailChange(res.data.info)
					}
				} else if (operation === 'create') {
					let currentInfoOperation = ''
					//如果进入时是编辑，但是拒绝同步，直接更新
					if (this.currentInfo.operation === 'edit') {
						currentInfoOperation = 'add'
					}

					delete payload.id
					if (this.customSectionId) {
            let res = await this.createCustomInfo({ id: this.customSectionId, payload })
						if (res.code === 1000) {
							this.cvDetailChange(res.data.info, currentInfoOperation)
						} else if (res.code === 80143) {
							// 显示超出模块最大限制
							this.showModuleMaxTips()
						}
					} else {
						delete payload.custom_section_id
						delete payload.id
						payload.category = type === 'custom' ? null : type
						let res = await this.createCustom(payload)
						if (res.code === 1000) {
							this.cvDetailChange(res.data.custom_section.infos[0])
						} else if (res.code === 80143) {
							// 显示超出模块最大限制
							this.showModuleMaxTips()
						} else {
							this.$message.error(res.message)
						}
					}
          setTimeout(() => {
            Message.closeAll()
          },1500)
				}
			},
			// 更新或者创建简历
			async cvDetailChange (data, currentInfoOperation) {
				let { type, operation } = this.currentInfo
				type = Number(type) >= 0 ? 'custom' : type
				let { submodule_info, basic_info, format_info, basic_info: { kind }, submodule_info: { sections_position, custom_sections_ids } } = this.cvDetail
				let infos = JSON.parse(JSON.stringify(this.experienceInfos))
				let position = JSON.parse(JSON.stringify(sections_position))
				// 判断是否需要创建简历
				const isCreate = kind === 'template' || kind === 'sample'
        const isSampleModule = this.customSectionId !== this.backUpInfo.data.custom_section_id && operation !== 'add'
				// 寻找当前模块是否在sections_position中
				const moduleIndex = sections_position.findIndex(item => item.type === 'custom' ? item.id === (this.customSectionId) : item.type === type)
				let infoIndex = -1
				if (moduleIndex > -1) {
					let ids = position[moduleIndex].info_ids
					infoIndex = ids.findIndex(item => item === this.backUpInfo.data.id)
				}
				// return
				let currentCustomSectionId = null // 当前编辑自定义模块的id
				// return
				// 如果当前简历里面没有此模块，则往section_positions里面push当前模块
				if (moduleIndex === -1 && operation === 'module') {
					if (operation === 'module') position.pop()
					position = [
						...position,
						{ type, id: data.custom_section_id, info_ids: [ data.id ] },
					]
				} else if (type === 'custom' && !this.customSectionId) {
					position.forEach(item => {
						if (item.id === this.currentInfo.data.custom_section_id || item.id === this.currentInfo.type) {
							item.id = data.custom_section_id
							item.info_ids = [ data.id ]
							item.type = 'custom'
						}
					})
				} else {
					position.forEach(item => {
						if ((item.type === type && item.type !== 'custom') || item.id === data.custom_section_id) {
							currentCustomSectionId = item.id
							item.id = data.custom_section_id
              if (isSampleModule) {
              	item.info_ids = [ data.id ]
              } else if (infoIndex > -1 && this.customSectionId === data.custom_section_id) {
	              item.info_ids[infoIndex] = data.id
              } else if (this.customSectionId === data.custom_section_id) {
	              item.info_ids = [ ...item.info_ids, data.id ]
              } else {
	              item.info_ids = [ data.id ]
              }
              item.info_ids = Array.from(new Set(item.info_ids))
						}
					})
				}
				let customsIds = position.filter(item => item.id)
				let res = {}
				let payload = {
					submodule_info: {
						...submodule_info,
            custom_sections_ids: customsIds.map(item => item.id),
						sections_position: position,
					},
					operation_type: isCreate ? '' : 'update_submodule_info'
				}
				if (!payload.submodule_info.custom_sections_titles[data.custom_section_id + '_title']) {
					payload.submodule_info.custom_sections_titles[data.custom_section_id + '_title'] = this.currentInfo.title
				}
				// if (window.location.href.includes('mentor')) {
				// 	res = await this.updateCvDetail({ operation_type: 'touch' })
				// } else
				if (isCreate) {
					payload = { ...payload, basic_info: { ...basic_info }, format_info }
					res = await this.createCvDetail({
						payload
					})
				} else {
					res = await this.updateCvDetail({ ...payload, saveModule: true })
				}
				if (res.code === 1000) {
					// if (window.location.href.includes('mentor')) {
					// 	const index = infos.findIndex(item => item.id === data.id)
					// 	infos[index] = data
					// } else
					if (operation === 'add' || operation === 'module') {
						infos[infos.length - 1] = data
					} else if (isSampleModule) {
						infos = [ data ]
          } else if (infoIndex > -1 && this.customSectionId === data.custom_section_id) {
						const index = infos.findIndex(item => item.id === this.backUpInfo.data.id)
						infos[index] = data
					} else if (this.customSectionId === data.custom_section_id) {
						infos = [ ...infos, data ]
					} else {
						infos = [ data ]
					}
					let moduleType = type === 'custom' ? data.custom_section_id : type
					if (type === 'custom') {
						let editorState = JSON.parse(JSON.stringify(this.$store.state.editor))
						editorState[moduleType] = infos
						this.$store.replaceState({
							...this.$store.state,
							editor: {
								...editorState,
								onePageFunction: this.$store.state.editor.onePageFunction,
								saveFormDataByDialog: this.$store.state.editor.saveFormDataByDialog,
                create_custom: []
							}
						})
					} else {
						this.setModuleData({ type: moduleType, info: infos })
					}
					//更新经历库模块信息
					this.updateExperienceModule({
						isCustom: type === 'custom',
						key: moduleType,
						info: data,
						operation: currentInfoOperation || operation,
						title: this.title || this.currentInfo.title,
						updateBackUp: true,
					})
					// //整理经历库标题
					// let experienceTitleList = this.experienceTitleList.concat([{
					// 	type:moduleType,
					// 	id: data.custom_section_id,
					// 	title:this.title || this.currentInfo.title || '未命名模块'
					// }])
					// this.updateExperienceTitleList(experienceTitleList)

					//整理模块管理模块选中状态
					this.getMenuList()
					this.resetEditState()
					this.setDealCheck(true)
					if (this.saveFormDataByDialog) {
						this.saveFormDataByDialog()
						this.setFormDataFn(null)
						// commit('setFormDataFn', null)
					}
				} else {
					this.$message.error(res.message)
				}
			},
			// 校验模块是否被引用
			async verifyFormData ({ custom_section_id, id }) {
				let res = await api.cvsEditor.customVerify(custom_section_id, id)
				if (res.code === 1000) {
					return res.data.imported
				} else {
					this.$message.error(res.message)
					return false
				}
			},
			// 修改模块标题
			async editModuleTitle () {
				if (this.isMentorEditor && this.currentInfo.operation !== 'module') {
					const alertData = {
						...this.alertData,
						messageContent: `
              <p>该模块已在用户简历中被引用，修改名称将同步更改用户的其他简历</p>
              <p style="color: #FF453E">确定要修改吗?</p>
            `,
						// messageTitle: '温馨提示',
						// inputData: {
						//   show: true,
						//   length: 15,
						//   value: this.currentInfo.title,
						//   showLength: true,
						//   placeholder: '请输入模块名称'
						// },
						cancel: close => {
							close()
						},
						confirm: (close, value) => {
							close()
							this.changeModuleName()
						}
					}
					this.setAlertData(alertData)
				} else if (!this.isMentorEditor) {
					this.changeModuleName()
				}
			},
			// 修改模块名称弹窗
			changeModuleName () {
				// if (operation !== 'edit') {
				// 	this.$message.error('请先保存模块')
				// 	return false
				// }
				let { data: { mentor_id }, type, operation } = this.currentInfo
				let { submodule_info, basic_info } = this.cvDetail
				// 点击确定的时候 让弹出
				const alertData = {
					...this.alertData,
					messageTitle: '修改模块名称',
					inputData: {
						show: true,
						length: 15,
						value: this.currentInfo.title,
						showLength: true,
						placeholder: '请输入模块名称'
					},
					cancel: close => {
						close()
					},
					confirm: async (close, value) => {
						if (this.customSectionId) {
							this.changeNameByApi(close, value)
							if (operation === 'edit') {
								this.updateCvDetail({
									operation_type: 'update_submodule_info',
									submodule_info
								})
							}
						} else {
							this.currentInfo.title = value
							close()
						}
					}
				}
				this.setAlertData(alertData)
			},
			// 通过接口修改模块名称
			async changeNameByApi(close, value) {
				let { submodule_info } = this.cvDetail
				let res = await api.cvsEditor.updateCustomTitle(this.customSectionId, {
					section_title: value,
					is_mentor: this.isMentorEditor
				})
				if (res.code === 1000) {
					close()
					this.$message.success('修改成功')
					//更新经历库模块名称
					this.updateExperienceTitleName({ type: this.currentInfo.type, title: value })
					//整理模块管理模块选中状态
					this.getMenuList()
					this.title = value
					submodule_info.custom_sections_titles[`${this.customSectionId}_title`] = value
				} else {
					this.$message.error(res.message)
				}
			},
			// 删除模块
			async deleteExperience () {
				const alertData = {
					...this.alertData,
					messageContent: `
          <p>删除后可以在页面右下角「经历库」内找回</p>
          <p style="color: #FF453E">确定删除本段经历吗?</p>
        `,
					confirm: async close => {
						let { submodule_info: { sections_position }, basic_info } = this.cvDetail
						let { custom_section_id, id } = this.formData
						let { type } = this.currentInfo
						let position = JSON.parse(JSON.stringify(sections_position))
						position.forEach((val, index) => {
							if (val.id === custom_section_id) {
                if(val.info_ids.length == 1){
                  position.splice(index, 1)
                }else {
                  val.info_ids = val.info_ids.filter(item => item !== id)
                }
							}
						})
						let payload = {
							operation_type: 'update_submodule_info',
							submodule_info: {
								sections_position: position
							}
						}
            if(basic_info.kind == 'sample' || basic_info.kind == 'template') {
              this.$message.error('请先编辑简历信息')
              return ;
            }
						let res = await this.updateCvDetail(payload)
						if (res.code === 1000) {
							close()
							this.$message.success('删除成功')
							let infos = this.experienceInfos.filter(item => item.id !== id)
							this.setModuleData({ type, info: infos })
							//删除经历库某个模块选中状态
							this.deleteExperienceSelect({ type, id })
							//重置
							this.resetEditState()
							this.getMenuList()
						} else {
							this.$message.error(res.message)
						}
					},
					cancel: close => {
						close()
					},
				}
				this.setAlertData(alertData)
			},
			//显示超出模块最大限制
			// showModuleMaxTips () {
			// 	console.log(this.alertData)
			// 	const alertData = {
			// 		...this.alertData,
			// 		messageTitle: '创建失败',
			// 		showCancelButton: false,
			// 		confirmButtonText: '我知道了',
			// 		messageContent: `当前模块下经历数量已达到上限，请打开右侧边栏「经历库」点击「管理」按钮，删除多余经历`,
			// 		confirm: async close => {
			// 			close()
			// 		},
			// 		cancel: close => {
			// 			close()
			// 		},
			// 	}
			// 	this.setAlertData(alertData)
			// },
		}
	}
</script>
<style lang="scss" scoped>
  .edit-module-content-main {
    padding: 0 28px;
    .edu-menu {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .edu-item {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #9C9C9C;
        cursor: pointer;
        .edu-item-select {
          width: 16px;
          height: 16px;
          border: 1px solid #DEDFE1;
          margin-right: 12px;
          text-align: center;
          line-height: 16px;
          &.active {
            .iconfont {
              font-size: 14px;
              margin: auto;
            }
          }
        }
        .iconfont {
          margin-right: 8px;
        }
      }
    }
    .edit-module-name {
      span {
        display: inline-block;
        max-width: 80%;
      }
      i {
        margin-left: 6px;
      }
    }
    .ai-cvs-entry {
      width: 88px;
      background: #FF7557;
      border-radius: 12px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 1;
      text-align: center;
      border: none;
      padding: 6px 0;
      &:hover {
        opacity: 0.8;
      }
    }
  }
</style>
